import { numberUnmask } from '../../utils/unmasks';

const Schema = {
  ssn: [{
    rule: 'required',
    isValid: (input) => {
      if (!input) {
        return 'The input field is required';
      }

      return numberUnmask(input).length < 4
        ? 'SSN is not valid'
        : true;
    },
  }],
};

export default Schema;
